import React, { FC } from 'react';

import { Select, SelectProps } from '../Select/Select';
import { Situacao, Situacoes, TransicaoSituacao } from 'model/solicitacao/Situacao';
import { SituacaoTag } from './SituacaoTag';
import { useAutorizacao } from '../Autorizacao/useAutorizacao';
import { Autorizacao } from '../Autorizacao/Autorizacao';
import { SelectOption } from '../Select/SelectItem';

interface SituacaoSelectProps extends SelectProps {
  situacao?: Situacao
  todas: boolean
}

export const SituacaoSelect: FC<SituacaoSelectProps> = props => {
  const autorizacao = useAutorizacao()
  const situacoes = getOptions(props.situacao, props.todas, autorizacao);
  const defaultValue = gerarOption(props.situacao ?? Situacoes.NAO_DEFINIDA);

  return (
    <Select 
      {...props}
      placeholder="Selecione uma situação"
      defaultValue={defaultValue}
      options={situacoes as any}
    />
  )
}


function getOptions(situacaoCorrente: Situacao|undefined, todas: boolean, autorizacao: Autorizacao): SelectOption[] {
  if (todas) {
    return Situacoes.asArray().map(it => gerarOption(it));

  } else {
    const situacao = situacaoCorrente ? Situacoes.byId(situacaoCorrente.id) : Situacoes.NAO_DEFINIDA
    const transicoes = new TransicaoSituacao(autorizacao).by(situacao)
    
    const situacoes = transicoes.map((transicao) => transicao.destino);
    situacoes.unshift(situacao);

    return situacoes.map(it => gerarOption(it));
  }
}

function gerarOption(situacao: Situacao): SelectOption {
  return { 'value': situacao.id, 'label': <SituacaoTag situacao={situacao} />};
}